import XRegExp from 'xregexp';
export const emailRegExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const nameRegExp = XRegExp("^[-.–'\\p{L}\\p{N}]+(?:\\s+[-.–'\\p{L}\\p{N}]+)*$");
